import React, {useState} from 'react';


const SearchBar = ({ onFormSubmit }) => {
	const [term, setTerm] = useState('')

	const onSubmit = event => {
		event.preventDefault();

		onFormSubmit(term);
	};

	return (
		<div className='search-bar hidden'>
			<div className='logo-container'>
				
				<h1>React Tube</h1>
			</div>
			<form onSubmit={onSubmit} className='form'>
				<div className='field'>
					<label>Video Search</label>
					<input
						type='text'
						value={term}
						onChange={(event) => setTerm(event.target.value)}
					/>
				</div>
			</form>
		</div>
	);
}

export default SearchBar;
